import { Typography } from "@mui/material";
import { IEmptyPageStyleProps } from "./IEmptyPageStyle";
import EmptyLoanStyle from "../../components/icons/EmptyLoanStyle";

export default function EmptyPageStyle({ prefixText,
    highlightedText,
    suffixText,
}: IEmptyPageStyleProps) {
    return (
        <div className="flex flex-col items-center justify-center" style={{ textAlign: 'center' }}>
            <EmptyLoanStyle className="mt-10 text-center text-[var(--primary-text-color)]" />
            <Typography className=" !mt-12 text-[var(--primary-text-color)]">
                {prefixText}  <span className="text-[#BBA57A] font-bold">{highlightedText}</span> {suffixText}.
            </Typography>
        </div>
    )
}
